import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { FormattedDate } from 'components/intl'
import { Modal } from 'containers/misc'
import { Button, FormData, Module, Status } from 'components/misc'
import { ContactRemove, ContactSettings } from 'containers/forms/contacts'
import { EmailSend } from 'containers/forms/emails'
import { apiCodeLists } from 'helpers/decorators/api'
import { PERSON_STATES, REMOVE_CONTACT_TYPES, ROLES } from 'constants/enums'
import { getActiveRole } from 'utils/token'
import { permissions } from '../../../../helpers/decorators'

@connect(({ auth }) => ({
  activeOrganization: auth.organization
}))
@apiCodeLists(['personStates'])
@permissions()
class ContactOverview extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    codeLists: PropTypes.object.isRequired,
    sendRecoveryPassword: PropTypes.func.isRequired,
    changePersonState: PropTypes.func.isRequired,
    orgContactDeletionTypes: PropTypes.array,
    onDeleteContact: PropTypes.func.isRequired,
    onDeactivateAccount: PropTypes.func.isRequired,
    permissions: PropTypes.object,
    persons: PropTypes.object
  }

  handleDialogClose = () => this.props.modal(null)

  render () {
    const {
      data,
      codeLists,
      orgContactDeletionTypes,
      activeOrganization,
      permissions: appPermissions,
      persons
    } = this.props

    const roles =  get(persons, 'roles', [])

    const hasAwardLeaderRole = roles.map(r => get(r, 'organizationContactRoleType.value') === ROLES.LEADER.role).includes(true)

    const role = getActiveRole(activeOrganization)

    const isActive = get(this.props,  'data.person.personState.value') === PERSON_STATES.active.id

    const actions = [
      {
        id: 2,
        label: 'Change status',
        intlKey: 'contact.change_contact_status',
        onClick: () => this.props.modal('contact-status-change')
      },
      {
        id: 3,
        label: 'Recover password',
        intlKey: 'participant.recover_password',
        onClick: () => this.props.modal('contact-recover-password')
      },
      {
        id: 4,
        label: 'Send test email',
        intlKey: 'contact.send_test_email',
        onClick: () => this.props.modal('send-test-email'),
        roles: [ROLES.IF_STAFF_SUPER.u]
      },
      {
        id: 5,
        label: 'Delete account',
        intlKey: 'participant.delete_account',
        onClick: () => this.props.modal('contact-account-remove')
      }
    ]

    if(hasAwardLeaderRole && (appPermissions.isIfSuper || appPermissions.isGbt || appPermissions.isNaoStaff || appPermissions.isGopStaff)){
      actions.push(
        {
          id: 6,
          label: 'Immediate Deactivation',
          intlKey: 'label.immediate_deactivation',
          onClick: () => this.props.modal('contact-deactivation')
        })
    }


    const actionsByRole = actions.filter(item => {
      if (item.roles) {
        return item.roles.some(
          actioRole => actioRole === role || actioRole === ROLES.ALL.u
        )
      }
      return item
    })

    const closeButton = (
      <div className="col-xs-6">
        <Button type="button" onClick={this.handleDialogClose} secondary>
          <FormattedMessage id="button.close" defaultMessage="Close" />
        </Button>
      </div>
    )


    return (
      <div>
        <Module
          title="Overview"
          intlKey="moduleTitle.overview"
          actionDropdown="Contact Settings"
          actionDropdownActions={actionsByRole}
          intlKeyAction="button.contact_settings"
          primary
          iconAction="settings"
          first
          grid
        >
          <div className="row">
            <div className="col-xs-3">
              <FormData label="Activation date" intlKey="label.activation_date">
                {get(data, 'person.createdAt') ? (
                  <FormattedDate value={get(data, 'person.createdAt')} />
                ) : (
                  '---'
                )}
              </FormData>
            </div>
            <div className="col-xs-3">
              <FormData label="State" intlKey="label.state">
                <Status state={get(data, 'person.personState')} />
              </FormData>
            </div>
          </div>
        </Module>

        <Modal id="contact-recover-password" compact customActions>
          <div className="row">
            <div className="col-xs-12">
              <h2 className="text--center">
                <FormattedMessage
                  id="participant.send_password_recovery_email"
                  defaultMessage="Send password recovery email?"
                />
              </h2>
            </div>
            {closeButton}
            <div className="col-xs-6 text--right">
              <Button
                type="button"
                onClick={() =>
                  this.props.sendRecoveryPassword(
                    get(data, 'email') || get(data, 'person.email')
                  )}
              >
                <FormattedMessage
                  id="button.confirm"
                  defaultMessage="Confirm"
                />
              </Button>
            </div>
          </div>
        </Modal>

        <Modal id="contact-deactivation" compact customActions>
          <div className="row">
            <div className="col-xs-12">
              <h2 className="text--center">
                <FormattedMessage
                  id="title.deactivate_account_title"
                  defaultMessage="Are you sure want to immediately deactivate this account?"
                />
              </h2>
            </div>
            <div className="col-xs-12">
              <div style={{ textAlign: 'center', margin: '10px 0px 30px 0px'}}>
                <FormattedMessage
                  id="label.deactivate_account_description"
                  defaultMessage="This should be used only in urgent cases because the participants will not be transferred to different award leader and so their requests may not be actioned."
                />
              </div>
            </div>
            {closeButton}
            <div className="col-xs-6 text--right">
              <Button
                type="button"
                negative
                onClick={() => this.props.onDeactivateAccount(get(data, 'person.id'), isActive)}
              >
                <FormattedMessage
                  id="button.remove"
                  defaultMessage="Remove"
                />
              </Button>
            </div>
          </div>
        </Modal>

        <Modal id="contact-account-remove" enableOverflow customActions>
          <ContactRemove
            id={get(data, 'id')}
            onDelete={this.props.onDeleteContact}
            reasonsList={orgContactDeletionTypes}
            contactRemoveType={REMOVE_CONTACT_TYPES.ORGANIZATION_CONTACT.value}
          />
        </Modal>

        <Modal id="contact-status-change" compact customActions>
          <ContactSettings
            data={get(data, 'person')}
            personStates={codeLists.personStates.list}
            changePersonState={this.props.changePersonState}
          />
        </Modal>
        <Modal id="send-test-email" customActions>
          <EmailSend
            onCancel={this.handleDialogClose}
            personId={get(data, 'person.id')}
          />
        </Modal>
      </div>
    )
  }
}

export default ContactOverview
